<template>
  <div class="visit">
    <!-- Add visit title -->

    <div v-if="checkFinishedVisit()">
      <h2 class="title">Visit {{ timeFormat(visit.startAt || visit.time) }}</h2>

      <prescription :prescription="visit.prescription" />

      <diagnose :diagnose="visit.diagnose" />

      <medical-analysis
        v-if="visit.medical_analysis"
        :medicalAnalysis="visit.medical_analysis"
      />

      <follow-ups :followUp="visit.follow_up" />
      
      <medicalMachineUsage
        :medicalMachineUsages="formattedMedicalMachinesUsages()"
      />
    </div>
    <div v-else>
      <h3 class="title">
        Unfinished visit created at {{ timeFormat(visit.time) }}
      </h3>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    prescription: require('./Prescription').default,
    diagnose: require('./Diagnose').default,
    MedicalAnalysis: require('./VisitAnalysis').default,
    FollowUps: require('./VisitFollowUp.vue').default,
    medicalMachineUsage: require('./MedicalMachineUsage').default
  },
  props: {
    visit: { type: Object, required: true },
    packages: { type: Array, required: true }
  },
  methods: {
    checkFinishedVisit() {
      return !!this.visit.finished_at;
    },
    getVisitString() {
      return JSON.stringify(this.visit);
    },
    timeFormat(time) {
      return window.moment(time).format('LLLL');
    },
    formattedMedicalMachinesUsages() {
      return this.visit.medical_machine_visit_detials.map(usage => ({
        ...usage,
        p: this.packages.find(p => p.id === usage.package_id)
      })).reduce((obj, usage) => ({
        ...obj,
        [usage.package_id]: usage
      }), {})
    }
  }
};
</script>

<style scoped>
.visit {
  margin: 8px 0px;
  padding: 10px 10px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 1px;
}

.title {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/patients/patient_log_componenets/visit_history_components/VisitHistory.vue